import type { Swimlane } from "../types";
import { getNanoId, nanoIdWithProcessId } from "../utils";

// Replaced from Date.now() to nano ids as in bulk duplication the ids will be same and will cause issues.
export const createSwimlane = ({
  processId,
  props
}: {
  processId: string;
  props?: Partial<Swimlane>;
}) => {
  const newSwimlane: Swimlane = {
    id: nanoIdWithProcessId(processId),
    name: "",
    //TODO: need to decide on this
    tag: `swimlane-${getNanoId()}`,
    steps: [],
    __modifiedAt: Date.now(),
    __createdAt: Date.now(),
    __tagReadonly: false,
    ...props
  };

  return newSwimlane;
};
